// extracted by mini-css-extract-plugin
export default {"sections":"GraphTabletDesktop_sections__JUmtw"};